import clsx from "clsx";
import { HTMLProps, PropsWithChildren } from "react";

function SectionHeader({ title }: { title: string }) {
  return <h4 className="p-3 m-0 text-base font-medium border-0 border-b border-solid border-neutral-200">{title}</h4>;
}

function SectionHeaderCustom({ children, ...rest }: HTMLProps<HTMLDivElement>) {
  return (
    <h4
      {...rest}
      className={clsx(
        "m-0 text-small font-medium p-3 border-solid border-0 border-b border-neutral-200",
        rest ? rest.className : ""
      )}
    >
      {children}
    </h4>
  );
}

function SectionBody({ children, bodyClasses }: { bodyClasses?: string } & PropsWithChildren) {
  return <div className={bodyClasses}>{children}</div>;
}

function Section({
  title,
  bodyClasses,
  children,
  ...rest
}: { title?: string; bodyClasses?: string } & HTMLProps<HTMLDivElement>) {
  return (
    <div data-testid="sidebar-section" className="relative bg-white" {...rest}>
      {title && <SectionHeader title={title} />}
      <SectionBody bodyClasses={bodyClasses}>{children}</SectionBody>
    </div>
  );
}

function SectionCustom({ children, ...rest }: HTMLProps<HTMLDivElement>) {
  return (
    <div data-testid="sidebar-section" className="relative bg-white" {...rest}>
      {children}
    </div>
  );
}

export { SectionHeader, SectionBody, Section, SectionCustom, SectionHeaderCustom };
